import { render, staticRenderFns, recyclableRender, components } from "./u-popup.vue?vue&type=template&id=30282a05&scoped=true&"
var renderjs
import script from "./u-popup.vue?vue&type=script&lang=js&"
export * from "./u-popup.vue?vue&type=script&lang=js&"
import style0 from "./u-popup.vue?vue&type=style&index=0&id=30282a05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30282a05",
  null,
  false,
  components,
  renderjs
)

export default component.exports